import UnderProgress from "../../tools/UnderProgress"

const SetTarget = () => {
  return (
    <div className="d-flex justify-content-center align-items-center">
      <UnderProgress />
    </div>
  )
}

export default SetTarget
